import { to_number } from './request_portal_helpers';

function fallback_main_sections(form_details = {}) {
  return Array.isArray(form_details?.sections)
    ? [{
      id: form_details?.id || 'main-section-1',
      main_section_name: form_details?.form_name || 'Case details',
      description: form_details?.form_description || '',
      order_number: 1,
      sub_sections: form_details.sections,
    }]
    : [];
}

function raw_main_sections(form_details = {}) {
  return Array.isArray(form_details?.main_sections) && form_details.main_sections.length
    ? form_details.main_sections
    : fallback_main_sections(form_details);
}

function question_with_form_metadata(question = {}, form_id, question_index = 0) {
  const question_id = question?.section_question_id || question?.question_id || question?.id || question_index;
  return {
    ...question,
    form_id,
    form_question_key: `${form_id}:${question_id}`,
  };
}

function sub_section_with_form_metadata(sub_section = {}, form_id, form_name, multi_form, sub_section_index = 0) {
  const section_name = String(sub_section?.section_name || sub_section?.name || '').trim();
  return {
    ...sub_section,
    id: sub_section?.id || sub_section?.section_id || `${form_id}-section-${sub_section_index}`,
    section_name: multi_form && section_name ? `${form_name} - ${section_name}` : section_name,
    form_id,
    questions: (Array.isArray(sub_section?.questions) ? sub_section.questions : [])
      .map((question, question_index) => question_with_form_metadata(question, form_id, question_index)),
  };
}

function main_section_with_form_metadata(main_section = {}, form_details = {}, multi_form, form_index = 0) {
  const form_id = to_number(form_details?.id);
  const form_name = String(form_details?.form_name || `Form ${form_index + 1}`).trim();

  return {
    ...main_section,
    id: main_section?.id || main_section?.main_section_id || `${form_id}-main-${form_index}`,
    main_section_name: multi_form
      ? `${form_name}${main_section?.main_section_name ? ` - ${main_section.main_section_name}` : ''}`
      : (main_section?.main_section_name || form_name),
    form_id,
    sub_sections: (Array.isArray(main_section?.sub_sections) ? main_section.sub_sections : [])
      .map((sub_section, sub_section_index) =>
        sub_section_with_form_metadata(sub_section, form_id, form_name, multi_form, sub_section_index)
      ),
  };
}

export function bound_form_ids(config_data = {}, selected_case_type = {}) {
  const binding_ids = (Array.isArray(config_data?.form_bindings) ? config_data.form_bindings : [])
    .filter((binding) => binding?.is_active !== false)
    .map((binding) => to_number(binding?.form || binding?.form_id))
    .filter(Boolean);

  return binding_ids.length
    ? [...new Set(binding_ids)]
    : (Array.isArray(selected_case_type?.form_ids) ? selected_case_type.form_ids : []).map(to_number).filter(Boolean);
}

export function combined_form_details(form_details_list = []) {
  const active_forms = form_details_list.filter((form_details) => form_details?.is_active !== false);
  const multi_form = active_forms.length > 1;

  return {
    id: 'requestor-bound-forms',
    form_name: multi_form ? 'Case details' : active_forms[0]?.form_name || 'Case details',
    form_description: multi_form
      ? 'Complete all assigned forms to open this case.'
      : active_forms[0]?.form_description || '',
    main_sections: active_forms.flatMap((form_details, form_index) =>
      raw_main_sections(form_details).map((main_section) =>
        main_section_with_form_metadata(main_section, form_details, multi_form, form_index)
      )
    ),
  };
}
